import { baseApi } from "./baseApi";

// Locations API
const locationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLocations: builder.query<any, any>({
      query: (params) => {
        let url = "locations";

        url += "?";

        if (params.all_pages) {
          url += `all_pages=${params.all_pages}&`;
        }

        if (params.page) {
          url += `page=${params.page}&`;
        }
        if (params.page_size) {
          url += `page_size=${params.page_size}&`;
        }
        if (params.include_all) {
          url += `include_all=${params.include_all}&`;
        }
        if (params.location_type) {
          url += `location_type=${params.location_type}&`;
        }
        if (params.parentId) {
          url += `parent_id=${params.parentId}&`;
        }
        if (params.name) {
          url += `name=${params.name}&`;
        }
        if (params.code) {
          url += `code=${params.code}&`;
        }

        // Remove the trailing '&' if any
        if (url.endsWith("&")) {
          url = url.slice(0, -1);
        }

        // Remove the trailing '?' if any
        if (url.endsWith("?")) {
          url = url.slice(0, -1);
        }

        return url;
      }
    }),
    createLocation: builder.mutation({
      query: (location) => ({
        url: "locations",
        method: "POST",
        body: location
      })
    }),
    updateLocation: builder.mutation({
      query: (params) => ({
        url: `locations/${params.id}`,
        method: "PUT",
        body: params.location
      })
    }),
    getLocation: builder.query({
      query: (id) => `locations/${id}`
    })
  })
});

export const {
  useGetLocationsQuery,
  useCreateLocationMutation,
  useUpdateLocationMutation,
  useGetLocationQuery
} = locationApi;
